module.exports = __webpack_public_path__ + "static/media/default_empty_logo.11824825.svg";